"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMerge = void 0;
/**
 * Merguje 2 obiekty "głęboko"
 *
 * @param {*} dst
 * @param {*} src
 * @returns
 */
function mergeProps(dst, src) {
    for (const key in src) {
        if (!src.hasOwnProperty(key)) {
            continue;
        }
        const element = src[key];
        const dstelement = dst[key];
        if (dstelement === undefined || element === null) {
            dst[key] = element;
            continue;
        }
        if (element === undefined) {
            continue;
        }
        if (Array.isArray(element) && typeof element[0] !== 'object') {
            dst[key] = element;
        }
        else if (typeof element === 'object' && typeof dstelement === 'object') {
            dst[key] = mergeProps(dst[key], element);
        }
        else {
            dst[key] = element;
        }
    }
    return dst;
}
/**
 * Merguje listę obiektów "głęboko"
 *
 * @export
 * @param {...any[]} jsonList
 * @returns
 */
function deepMerge(...jsonList) {
    if (!jsonList.length) {
        return;
    }
    if (jsonList.length === 1) {
        return jsonList[0];
    }
    const result = Object.assign({}, JSON.parse(JSON.stringify(jsonList.shift())));
    jsonList.forEach((json) => mergeProps(result, json));
    return result;
}
exports.deepMerge = deepMerge;
//# sourceMappingURL=deepMerge.js.map